const  MuiDrawer={
    styleOverrides: {
        paper: {
            color: "#fff",
            background: "#00ACFF",
        },
    }
}
export default  MuiDrawer;